// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import projectMilestoneEntity from './entities/project-milestone.json';
import projectMilestoneMenu from '../pages/project-milestone/menu.json';
import projectMilestoneFullForm from '../pages/project-milestone/forms/full.json';
import projectMilestoneContextForm from '../pages/project-milestone/forms/context.json';
import projectMilestoneMiniForm from '../pages/project-milestone/forms/mini.json';
import projectMilestoneLookupForm from '../pages/project-milestone/forms/lookup.json';
import projectMilestoneTableView from '../pages/project-milestone/views/table.json';
import projectMilestoneCardsView from '../pages/project-milestone/views/cards.json';
import projectMilestoneDashboardView from '../pages/project-milestone/views/dashboard.json';

/** Тип запису «Віха проєкту» зі сторінками пакета: меню, форми та подання з pages/project-milestone/. */
export const projectMilestoneDefinition: IRecordTypeDefinition = {
  ...projectMilestoneEntity,
  views: assembleViewSet({
      table: projectMilestoneTableView,
      cards: projectMilestoneCardsView,
      dashboard: projectMilestoneDashboardView,
  }),
  form: projectMilestoneFullForm,
  forms: { full: projectMilestoneFullForm, context: projectMilestoneContextForm, mini: projectMilestoneMiniForm, lookup: projectMilestoneLookupForm },
  menu: projectMilestoneMenu,
} as IRecordTypeDefinition;
